export const Grain = () => <div className="grain-overlay" aria-hidden="true" />;

// Refined typographic wordmark for NODINO with a small gold monogram diamond.
export function Wordmark({ className = "", onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid="brand-logo"
      className={`group flex items-center gap-2.5 ${className}`}
      aria-label="NODINO"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="shrink-0">
        <path
          d="M4 20 L4 4 L20 20 L20 4"
          stroke="#D4AF37"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="2.4" stroke="#AA8C2C" strokeWidth="1.2" />
      </svg>
      <span className="font-display text-xl md:text-2xl tracking-[0.28em] leading-none pt-0.5">
        NODINO
      </span>
    </button>
  );
}
